import { Component, input, output, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-combo-input',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule
  ],
  templateUrl: './combo-input.component.html',
  styleUrls: ['./combo-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboInputComponent),
      multi: true
    }
  ]
})

export class ComboInputComponent implements ControlValueAccessor {
  label = input<string>('Select or Enter');
  placeholder = input<string>('Type or select...');
  options = input<string[]>([]);
  valueChange = output<string>();

  inputValue: string = '';
  filteredOptions: string[] = [];
  disabled: boolean = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    this.filteredOptions = this.options();
  }

  onInputChange(value: string): void {
    this.inputValue = value;
    this.filterOptions(value);
    this.onChange(value);
    this.valueChange.emit(value);
  }

  onOptionSelected(event: any): void {
    const value = event.option.value;
    this.inputValue = value;
    this.onChange(value);
    this.valueChange.emit(value);
  }

  private filterOptions(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredOptions = this.options().filter(option =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // ControlValueAccessor implementation
  writeValue(value: string): void {
    this.inputValue = value || '';
    this.filterOptions(this.inputValue);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}